import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			fill: "#531DAB",
			children: [/* @__PURE__ */ _jsx("path", { d: "m24 21.119-2.646-2.647c.397-.365.646-.89.646-1.472l2 2v2.119Zm0-8-2-2v-2.12l2 2v2.12Zm0-7.281L18.162 0h2.12L24 3.719v2.119ZM10.881 0h2.12l5 5h-2.12l-5-5Zm-8 0h2.12l5 5H7.88l-5-5ZM0 6.119v-2.12l2.177 2.178C2.063 6.427 2 6.707 2 7v1.119l-2-2Zm0 8v-2.12l2 2v2.12l-2-2Zm0 7.76v-2.12L4.24 24H2.122L0 21.878ZM12 24H9.881l-5-5h2.12l5 5Zm8 0h-2.119l-5-5h2.12l5 5Z" }), /* @__PURE__ */ _jsx("rect", {
				width: 18,
				height: 12,
				x: 3,
				y: 6,
				rx: 1
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0 0h24v24H0z",
				fill: "#fff"
			})
		}) })
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cg%20fill%3D%22%23531DAB%22%3E%3Cpath%20d%3D%22m24%2021.119-2.646-2.647c.397-.365.646-.89.646-1.472l2%202v2.119Zm0-8-2-2v-2.12l2%202v2.12Zm0-7.281L18.162%200h2.12L24%203.719v2.119ZM10.881%200h2.12l5%205h-2.12l-5-5Zm-8%200h2.12l5%205H7.88l-5-5ZM0%206.119v-2.12l2.177%202.178C2.063%206.427%202%206.707%202%207v1.119l-2-2Zm0%208v-2.12l2%202v2.12l-2-2Zm0%207.76v-2.12L4.24%2024H2.122L0%2021.878ZM12%2024H9.881l-5-5h2.12l5%205Zm8%200h-2.119l-5-5h2.12l5%205Z%22%2F%3E%3Crect%20width%3D%2218%22%20height%3D%2212%22%20x%3D%223%22%20y%3D%226%22%20rx%3D%221%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22a%22%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22%23fff%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";
